import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import './ToolPage.css'
import './SecretSantaReveal.css'
import { decryptText } from './utils/burnCrypto'
import { consumeBurnMessage } from './utils/burnMessageStore'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const SecretSantaReveal = () => {
  useDocumentMeta({
    title: 'Revelar Amigo Secreto | jarder.dev',
    description: 'Veja quem você tirou no amigo secreto.',
  })

  const location = useLocation()
  const [status, setStatus] = useState('idle')
  const [assignment, setAssignment] = useState(null)

  const params = new URLSearchParams(location.search)
  const id = params.get('id')
  const keyBase64Url = location.hash.slice(1)

  const reveal = async () => {
    if (!id || !keyBase64Url) {
      setStatus('invalid')
      return
    }
    setStatus('loading')
    try {
      const record = await consumeBurnMessage(id)
      if (!record) {
        setStatus('gone')
        return
      }
      const text = await decryptText({
        ciphertext: record.ciphertext,
        iv: record.iv,
        keyBase64Url,
      })
      setAssignment(JSON.parse(text))
      setStatus('revealed')
      trackEvent('tool_generate', { tool: 'secret_santa_reveal' })
    } catch {
      setStatus('error')
    }
  }

  const infoSection = (
    <div className="tool-info-section">
      <h2>Como funciona esse link</h2>
      <p>
        Cada participante recebe um link individual, gerado no momento
        do sorteio. Ele{' '}
        <strong>só pode ser aberto uma única vez</strong>: assim que
        você revela quem tirou, o link se torna inválido pra sempre.
        Nem você, nem o organizador, nem mais ninguém consegue abri-lo
        de novo.
      </p>
      <p>
        Quer organizar o seu próprio amigo secreto?{' '}
        <Link to="/ferramentas/amigo-secreto">
          Sorteie aqui e gere os links
        </Link>
        .
      </p>
    </div>
  )

  if (status === 'invalid' || (!id && !keyBase64Url)) {
    return (
      <div className="tool-page">
        <Link to="/ferramentas/amigo-secreto" className="tool-back-link">
          ← Sortear amigo secreto
        </Link>
        <h1>Link inválido</h1>
        <p className="tool-disclaimer">
          Esse link de amigo secreto parece incompleto ou inválido. Se
          ele chegou cortado (por exemplo, quebrado em duas linhas numa
          mensagem), peça pro organizador reenviar o link completo,
          copiado e colado inteiro.
        </p>
        {infoSection}
      </div>
    )
  }

  return (
    <div className="tool-page secret-santa-reveal">
      <h1>
        Amigo Secreto{' '}
        <span role="img" aria-label="presente">
          🎁
        </span>
      </h1>

      {status === 'idle' && (
        <>
          <p className="tool-disclaimer">
            Toque no botão abaixo para descobrir quem você tirou. Isso só
            pode ser feito uma vez, depois de revelar, o link deixa de
            funcionar.
          </p>
          <button type="button" className="tool-button" onClick={reveal}>
            Revelar
          </button>
        </>
      )}

      {status === 'loading' && <p>Descriptografando...</p>}

      {status === 'revealed' && assignment && (
        <div className="tool-result-card secret-santa-result">
          <span className="tool-result-label">
            Olá, {assignment.from}! Você tirou
          </span>
          <span className="tool-result-value">{assignment.to}</span>
        </div>
      )}

      {status === 'gone' && (
        <p className="tool-error">
          Esse link já foi aberto antes (ou nunca existiu). Não é mais
          possível recuperá-lo. Peça pro organizador conferir com você
          diretamente.
        </p>
      )}

      {status === 'error' && (
        <p className="tool-error">
          Não foi possível revelar agora. Tente novamente em instantes.
        </p>
      )}

      {infoSection}
    </div>
  )
}

export default SecretSantaReveal
